import { Record as ImmutableRecord } from 'immutable'
import { UserAction, UserActions, UserValue } from 'lib/actions/user'
import { UserSearchAction, UserSearchActions } from 'lib/actions/user/user-search'
import { initialDeleteReturn, initialGetReturn, initialListReturn } from 'lib/rpc'

export class UsersState extends ImmutableRecord({
    list: initialListReturn<UserValue>(),
    listManaged: initialListReturn<UserValue>(),
    item: initialGetReturn<UserValue>(),
    manyItem: initialListReturn<UserValue>(),
    deleted: initialDeleteReturn(),
}) {}

export const initialUsersState: UsersState = new UsersState()

export const UsersReducer = (state: UsersState, action: UserActions | UserSearchActions): UsersState => {
    switch (action.type) {
        case UserAction.getUser:
            return state.set('item', action.payload)
        case UserAction.introspect:
            return state.set('item', action.payload)
        case UserSearchAction.search:
            return state.set('list', action.payload)
        case UserSearchAction.searchManagedUsers:
            return state.set('listManaged', action.payload)
        case UserAction.setRoles:
            return state.set('item', action.payload)
        default:
            return state
    }
}
